<template>
  <el-dialog
    title="音檔檢查員-選擇頻道"
    fullscreen
    @close="handleDlgClose"
    :visible.sync="innerVisible"
  >
    <div class="container" v-loading="isLoading">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                size="small"
                v-model="queryForm.qstr"
                placeholder="頻道名稱"
                style="width:180px"
              ></el-input>
            </el-form-item>

            <el-form-item label=" " label-width="15px">
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="funcpanel">
          <el-button
            type="primary"
            @click="handleBatchAudit"
            size="small"
            :disabled="selectedRow.length === 0"
            >批次檢視音檔</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-user" /> 人員名稱：{{ mbrName }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            :data="channels"
            v-loading="isLoading"
            ref="dataTable"
            @sort-change="sortChange"
            @selection-change="handleSelectionChange"
            :default-sort="{ prop: defaultSortCol, order: defaultOrder }"
            stripe
            style="width: 100%"
          >
            <el-table-column type="selection" width="45"> </el-table-column>

            <el-table-column
              type="index"
              :index="indexFormatter"
              prop="id"
              fixed
            >
            </el-table-column>

            <el-table-column
              label="頻道名稱"
              prop="name"
              sortable="custom"
              width="250"
            >
              <template #default="scope">
                <el-tag :style="getTagStyle(scope.row.color)">{{
                  scope.row.name
                }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template #default="scope">
                <el-button size="mini" @click="auditOneChannel(scope.row)"
                  >單頻道檢視音檔
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </CRow>
        <CRow>
          <!--<el-pagination-->
          <!--@size-change="handleSizeChange"-->
          <!--@current-change="handleCurrentChange"-->
          <!--:current-page.sync="currentPage"-->
          <!--:page-sizes="[50, 100, 200]"-->
          <!--:page-size="pageSize"-->
          <!--layout="total, sizes, prev, pager, next, jumper"-->
          <!--:total="total" >-->
          <!--</el-pagination>-->
        </CRow>
      </CCardBody>
    </CCard>

    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">關閉</el-button>
    </template>
  </el-dialog>
</template>

<script>
import tagColorsMixin from "@/components/mixin/tagColors.js";
import API from "@/api/";
export default {
  mixins: [tagColorsMixin],
  components: {},

  model: {
    prop: "visible",
    event: "toggleVisible",
  },

  created() {
    this.sort = this.defaultSortCol;
    this.order = this.defaultOrder;
    if (this.innerVisible) {
      this.query(this.pageSize, 0, this.sort, this.order, this.activeQueryForm);
    }
  },

  props: {
    visible: {
      type: Boolean,
    },
    mbrId: {
      type: Number,
    },
    mbrName: {
      type: String,
    },
  },

  data() {
    return {
      channels: [],
      total: 0,
      offset: 0,
      sort: "",
      order: "descending",

      selectedRow: [],
      isLoading: false,
      defaultSortCol: "name",
      defaultOrder: "ascending",
      //pageSize: 50,
      pageSize: 99999, //no pagination for now
      currentPage: 1,
      queryForm: {
        qstr: "",
        //colors: [],
      },
      activeQueryForm: {
        qstr: "",
        //colors: [],
      },
    };
  },

  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },

  methods: {
    auditOneChannel(row) {
      const chnIds = [row.id];
      this.auditSelectedChannels(chnIds);
    },

    auditSelectedChannels(ids) {
      this.innerVisible = false;
      this.$emit("startAudit", this.mbrId, this.mbrName, ids);
    },

    handleBatchAudit() {
      const ids = this.selectedRow.map(row => row.id);
      this.auditSelectedChannels(ids);
    },

    handleSelectionChange(rows) {
      //console.log(`handleSelectionChange: val = ${JSON.stringify(rows)}`);
      this.selectedRow = rows;
    },

    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.activeQueryForm = { ...queryForm };
      this.isLoading = true;
      this.query(
        this.pageSize,
        0,
        this.sort,
        this.order,
        this.activeQueryForm
      ).then(() => (this.isLoading = false));
    },

    //handleSizeChange(val) {
    //this.pageSize = val;
    //this.query(val, this.offset, this.sort, this.order, this.activeQueryForm);
    //},

    //handleCurrentChange(page) {
    //this.query(
    //this.pageSize,
    //this.pageSize * (page - 1),
    //this.sort,
    //this.order,
    //this.activeQueryForm
    //);
    //},

    query(max, offset, sort, order, params) {
      const newParams = {
        max: max,
        offset: offset,
        sort,
        order,
        member: this.mbrId,
        ...params,
      };

      return API.audit
        .getMbrChannels(newParams)
        .then(res => {
          if (res.status === 200) {
            this.channels = res.data;
            this.total = res.data.length;
            this.offset = offset;
            return res;
          } else {
            return Promise.reject(res);
          }
        })
        .finally(() => {});
    },

    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },

    sortChange(args) {
      if (args.order === null) {
        this.sort = this.defaultSortCol;
        this.order = this.defaultOrder;
      } else {
        this.sort = args.prop;
        this.order = args.order;
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    handleDlgClose() {},
  },
};
</script>

<style scoped></style>
